import { configureSupportLinkURL } from 'spark-api/safetyLetter/commonSafetyLetterService';
import { appConfig } from '../../../config/appConfig';

/**
 * Shared support-link helpers for the Apollo shell (header profile, footer).
 * Centralizes logic formerly duplicated in Footer.js SupportLink and NotFound.js.
 * SAF-18222: external links use noopener/noreferrer to prevent reverse tabnabbing.
 */

/** Builds a sponsor-aware IQVIA support URL from user, enterprise, and current path. */
export function buildSupportLink(user, mappedEnterprise, pathname) {
    const sponsor =
        mappedEnterprise &&
        mappedEnterprise.filter((enterprise) => enterprise.entId === parseInt(user.enterpriseId, 10));
    const supportURL =
        sponsor && sponsor.length
            ? sponsor[0].supportURL
                ? sponsor[0].supportURL.split('?')[0]
                : ''
            : configureSupportLinkURL;

    // Query params match legacy SupportLink URL shape for IQVIA support portal routing.
    return `${supportURL}?emailAddress=${user.email}&firstName=${user.given_name}&lastName=${
        user.family_name
    }&moduleName=${appConfig.MODULE_NAME}&redirectURL=${process.env.PUBLIC_URL}${pathname}${
        sponsor && sponsor.length ? `&sponsor=${encodeURIComponent(sponsor[0].entName)}` : ''
    }`;
}

/** Opens an external URL in a new tab with reverse-tabnabbing protection. */
export function openExternalLink(url) {
    window.open(url, '_blank', 'noopener,noreferrer');
}
